import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { isNil, noop } from 'lodash';
import { useTranslation } from 'react-i18next';
import { CJStringValidationSchema } from 'validators/schemas.validation';
// Import UI Components
import { ExtendedInput } from '@geneui/components';
// Import Components
import CJMenuItemDropdown from './CJMenuItemDropDown';
// Import Services
import { getCustomerJourneyFormFieldTranslatableErrorText } from 'services/customerJourney/helpers';

const CJString = ({ defaultValue, getUpdate, option }) => {
    const { t } = useTranslation();
    const { CustomAttributes } = option;
    const formik = useFormik({
        initialValues: {
            value: defaultValue?.value,
        },
        onSubmit: noop,
        validationSchema: CJStringValidationSchema(option),
    });
    const { values, setFieldValue, errors, submitForm } = formik;
    const { value } = values;

    const onChangeHandler = ({ target }) => {
        setFieldValue('value', target?.value);
    };

    useEffect(() => {
        getUpdate({ isValid: !errors.value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errors]);

    useEffect(() => {
        getUpdate({ value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        submitForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isNil(CustomAttributes?.MenuItemId)) {
        return (
            <CJMenuItemDropdown
                defaultValue={defaultValue}
                option={option}
                getUpdate={getUpdate}
                isMultiselect={false}
            />
        );
    } else {
        return (
            <ExtendedInput
                type="text"
                placeholder={t(CustomAttributes?.DisplayName)}
                label={t(CustomAttributes?.DisplayName)}
                labelAppearance="swap"
                onChange={onChangeHandler}
                value={value}
                isValid={!errors.value}
                errorText={getCustomerJourneyFormFieldTranslatableErrorText(t, errors?.value)}
            />
        );
    }
};

CJString.propTypes = {
    defaultValue: PropTypes.shape({ value: PropTypes.string }),
    getUpdate: PropTypes.func.isRequired,
    option: PropTypes.object.isRequired,
};

CJString.defaultProps = {
    defaultValue: { value: '' },
};

export default memo(CJString);
